import { Transition as MantineTransition } from '@mantine/core';

import { Transition as ThemeTransition } from '../../theme';
import { StyledWrapper } from './Transition.style';

export const transitionTypes = [
  'fade',
  'scale',
  'scale-y',
  'scale-x',
  'skew-up',
  'skew-down',
  'rotate-left',
  'rotate-right',
  'slide-down',
  'slide-up',
  'slide-left',
  'slide-right',
  'pop',
  'pop-bottom-left',
  'pop-bottom-right',
  'pop-top-left',
  'pop-top-right',
] as const;
export type TransitionType = (typeof transitionTypes)[number];

export interface TransitionProps {
  animation?: TransitionType;
  children: React.ReactNode;
  duration?: number;
  visible?: boolean;
  keepMounted?: boolean;
  minHeight?: number;
}

export function Transition({
  animation = 'fade',
  children,
  duration = ThemeTransition.Duration.In,
  visible = true,
  keepMounted = false,
  minHeight = 120,
}: TransitionProps) {
  return (
    <MantineTransition
      duration={duration}
      mounted={visible}
      timingFunction="ease"
      transition={animation}
      keepMounted={keepMounted}
    >
      {(styles) => (
        <StyledWrapper
          style={{
            ...styles,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            minHeight,
            height: '100%',
          }}
        >
          {children}
        </StyledWrapper>
      )}
    </MantineTransition>
  );
}
